// /app/frontend/src/components/frugal-v2/components/EmailsModal.jsx
// Modal wrapper for EmailsTab (35 lines)

import React from 'react';
import EmailsTab from '../tabs/EmailsTab';

const EmailsModal = ({ 
  isOpen, 
  onClose, 
  token, 
  expenses,
  incomes,
  onRefresh, 
  emailsEnabled, 
  onUpgrade,
  t 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-slate-900 rounded-xl mx-4 max-w-lg w-full max-h-[90vh] overflow-hidden border border-white/10">
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <h3 className="text-lg font-semibold text-white">{t('frugal.tabs.emails')}</h3>
          <button 
            onClick={onClose}
            className="text-slate-400 hover:text-white p-1"
          >
            ✕
          </button>
        </div>
        <div className="max-h-[calc(90vh-60px)] overflow-y-auto p-4">
          <EmailsTab 
            token={token} 
            expenses={expenses}
            incomes={incomes}
            t={t} 
            onRefresh={onRefresh}
            emailsEnabled={emailsEnabled}
            onUpgrade={onUpgrade}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailsModal;
